import { Box, Card, CardMedia, Grid2, Stack, Typography } from "@mui/material";
import React from "react";
import { APP_IMAGES } from "../../assets";
import Grid from "@mui/material/Grid2";

const ItemCard = ({ val }) => {
  return (
    <Card
      sx={{
        border: "1px solid #DBDBDB",
        boxShadow: "none",
      }}
    >
      <Grid container>
        <Grid size={{ xs: 12, sm: 3 }}>
          <Box
            p={1}
            height={160}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <img src={val?.productImages[0]} width={"100%"} />
          </Box>
        </Grid>
        <Grid
          p={2}
          size={{ xs: 12, sm: 9 }}
          bgcolor={"customColor.moonRaker"}
          position={"relative"}
        >
          <Typography fontSize={"1.125rem"} fontWeight={600}>
            {val?.productName}
          </Typography>
          <Typography
            variant={"body2"}
            mt={1}
            sx={{
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {val?.productDescription}
          </Typography>
          <Stack
            mt={3}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
          >
            <Typography variant={"body1"} fontWeight={600}>
              Remaining stock {val?.productStock}
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {val.activeDiscount ? (
                <>
                  <span style={{ color: "gray", fontWeight: "bold" }}>
                    $
                    {(
                      val.productPrice -
                      (val.productPrice * val.discountRatio) / 100
                    )?.toFixed(2)}
                  </span>{" "}
                  <span
                    style={{
                      textDecoration: "line-through",

                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    ${val.productPrice}
                  </span>
                </>
              ) : (
                <>Price ${val.productPrice}</>
              )}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ItemCard;
